import { Chart } from 'primereact/chart';
import { Toast } from 'primereact/toast';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

import Card from '../../../Base/Components/Card/Card';
import { toastShow } from '../../../Base/Services/ToastService';
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';


import { getProduccionFechaSemanaTejido, getProduccionFechaTejido } from '../../../API/Produccion/KPIs/KPIs';

import {
    borderRadius, borderColorCotton, colorCotton, borderColorSintetico, colorSintetico, footer,
    heightKPI, datalabelsBar, datalabelsLine, getRangeWeek, getScales, getTitle
} from '../../../utils/KPIs/productionUtils';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';


const KnittingProduction = () => {

    const { config } = useContext(ConfigContext);

    const scales = getScales(config);
    const colorTitle = getTitle(config);

    const toast = useRef(null);
    const [dates, setDates] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [knittingWeek, setKnittingWeek] = useState(null);
    const [knittingDay, setKnittingDay] = useState(null);
    const [knittingCircularDataWeek, setKnittingCircularDataWeek] = useState({
        OptionsWeek: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Circular (Kg)',
                    color: colorTitle,
                },
                datalabels: datalabelsBar,
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
            },
            scales: scales
        },
        OptionsDay: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Circular (Kg)',
                    color: colorTitle,
                },
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
                datalabels: datalabelsLine,
                aspectRatio: 5 / 3,
                layout: {
                    padding: {
                        top: 32,
                        right: 16,
                        bottom: 16,
                        left: 8
                    }
                },
                elements: {
                    line: {
                        fill: false,
                        tension: 0.4
                    }
                },
            },
            scales: scales
        },
        data: null
    });
    const [knittingCircularDataDays, setKnittingCircularDataDays] = useState({
        OptionsWeek: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Circular (Kg)',
                    color: colorTitle,
                },
                datalabels: datalabelsBar,
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
            },
            scales: scales
        },
        OptionsDay: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Circular (Kg)',
                    color: colorTitle,
                },
                tooltip: {
                    callbacks: {
                        footer: footer,
                    }
                },
                datalabels: datalabelsLine,
                aspectRatio: 5 / 3,
                layout: {
                    padding: {
                        top: 32,
                        right: 16,
                        bottom: 16,
                        left: 8
                    }
                },
                elements: {
                    line: {
                        fill: false,
                        tension: 0.4
                    }
                },
            },
            scales: scales
        },
        data: null
    });
    const [knittingTricotDataWeek, setKnittingTricotDataWeek] = useState({
        OptionsWeek: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Tricot (Kg)',
                    color: colorTitle,
                },
                datalabels: datalabelsBar,

            },
            scales: scales
        },
        OptionsDay: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Tricot (Kg)',
                },
                datalabels: datalabelsLine,
                aspectRatio: 5 / 3,
                layout: {
                    padding: {
                        top: 32,
                        right: 16,
                        bottom: 16,
                        left: 8
                    }
                },
                elements: {
                    line: {
                        fill: false,
                        tension: 0.4
                    }
                },
            },
            scales: scales
        },
        data: null
    });
    const [knittingTricotDataDays, setKnittingTricotDataDays] = useState({
        OptionsDay: {
            interaction: {
                intersect: false,
                mode: 'index',
            },
            plugins: {
                title: {
                    display: true,
                    text: 'Tricot (Kg)',
                    color: colorTitle,
                },
                datalabels: datalabelsLine,
                aspectRatio: 5 / 3,
                layout: {
                    padding: {
                        top: 32,
                        right: 16,
                        bottom: 16,
                        left: 8
                    }
                },
                elements: {
                    line: {
                        fill: false,
                        tension: 0.4
                    }
                },
            },
            scales: scales
        },
        data: null
    });




    const getInfo = async () => {

        if (dates) {
            setLoading(true);
            const rangeWeeks = getRangeWeek(dates)

            const tempo = await getProduccionFechaSemanaTejido(rangeWeeks);
            const tempo2 = await getProduccionFechaTejido(rangeWeeks);
            // console.log(tempo, tempo2)
            const aux = {
                days: [],
                KgsTC: [],
                KgsTS: [],
                KgsTT: []
            }
            const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
            days.forEach((day, index) => {
                const tempo = tempo2.find((item) => item.NombreDia === day);
                if (tempo) {
                    aux.days.push(day);
                    aux.KgsTC.push(tempo.KgsTC);
                    aux.KgsTS.push(tempo.KgsTS);
                    aux.KgsTT.push(tempo.KgsTT);
                } else {
                    aux.days.push(day);
                    aux.KgsTC.push(0);
                    aux.KgsTS.push(0);
                    aux.KgsTT.push(0);
                }
            });
            // tempo2.forEach((day) => {
            //     aux.days.push(day.NombreDia);
            //     aux.KgsTC.push(day.KgsTC);
            //     aux.KgsTS.push(day.KgsTS);
            //     aux.KgsTT.push(day.KgsTT);
            // })
            setKnittingWeek(tempo[0]);
            setKnittingDay(aux);
            // console.log(aux)

            setLoading(false)
        } else {
            toastShow(toast, 'warn', 'Seleccione una fecha.')
        }
        setLoading(false)
    }


    useEffect(() => {
        window.document.title = 'PPF • Knitting Production'
        getInfo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (knittingWeek) {
            setKnittingCircularDataWeek({
                ...knittingCircularDataWeek,
                dataWeek: {
                    labels: [`Semana ${knittingWeek.Semana}`],
                    datasets: [{
                        type: 'bar',
                        label: 'Cotton',
                        backgroundColor: colorCotton,
                        borderColor: borderColorCotton,
                        borderWidth: 2,
                        data: [knittingWeek.KgsTC],
                        stack: 'Stack 0',
                        borderRadius: borderRadius
                    },
                    {
                        type: 'bar',
                        label: 'Poly',
                        backgroundColor: colorSintetico,
                        borderColor: borderColorSintetico,
                        borderWidth: 2,
                        data: [knittingWeek.KgsTS],
                        stack: 'Stack 1',
                        borderRadius: borderRadius
                    },
                    ]
                }
            })
            setKnittingTricotDataWeek({
                ...knittingTricotDataWeek,
                dataWeek: {
                    labels: [`Semana ${knittingWeek.Semana}`],
                    datasets: [{
                        type: 'bar',
                        label: 'Poly',
                        backgroundColor: colorSintetico,
                        borderColor: borderColorSintetico,
                        borderWidth: 2,
                        data: [knittingWeek.KgsTT],
                        stack: 'Stack 0',
                        borderRadius: borderRadius
                    }]
                }
            })
        }else{
            setKnittingCircularDataWeek({
                ...knittingCircularDataWeek,
                dataWeek: null
            })
            setKnittingTricotDataWeek({
                ...knittingTricotDataWeek,
                dataWeek: null
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [knittingDay])


    useEffect(() => {
        if (knittingDay) {
            setKnittingCircularDataDays({
                ...knittingCircularDataDays,
                dataDay: {
                    labels: knittingDay.days,
                    datasets: [{
                        type: 'line',
                        label: 'Cotton',
                        backgroundColor: colorCotton,
                        borderColor: borderColorCotton,
                        borderWidth: 2,
                        data: knittingDay.KgsTC,
                        borderRadius: borderRadius,
                        stack: 'Stack 0',
                    },
                    {
                        type: 'line',
                        label: 'Poly',
                        backgroundColor: colorSintetico,
                        borderColor: borderColorSintetico,
                        borderWidth: 2,
                        data: knittingDay.KgsTS,
                        borderRadius: borderRadius,
                        stack: 'Stack 1',
                    }
                    ]
                }
            })
            setKnittingTricotDataDays({
                ...knittingTricotDataDays,
                dataDay: {
                    labels: knittingDay.days,
                    datasets: [{
                        type: 'line',
                        label: 'Poly',
                        backgroundColor: colorSintetico,
                        borderColor: borderColorSintetico,
                        borderWidth: 2,
                        data: knittingDay.KgsTT,
                        borderRadius: borderRadius,
                        stack: 'Stack 0',
                    },]
                }
            })
        } else {
            const reset = {
                datasets: [{
                    data: [],
                },]
            }
            setKnittingCircularDataDays({
                ...knittingCircularDataDays,
                dataDay: reset
            })
            setKnittingTricotDataDays({
                ...knittingTricotDataDays,
                dataDay: reset
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [knittingDay])

    return (
        <div className='p-3'>
            <Card titulo={<h4>Knitting production</h4>} contenido={
                (<div className='p-3 transitionAll-1 kpiProducction'>
                    <div>

                        <Toast position="bottom-right" ref={toast} />
                        <CalendarWeek
                            date={dates}
                            setDate={setDates}
                            loading={loading}
                            buscar={getInfo}
                        />
                    </div>
                    {loading ?
                        <div hidden={loading} style={{ height: '100%', zIndex: 1000, width: '100%', background: 'rgba(204, 204, 204, 0.5)', position: loading ? 'absolute' : 'none', paddingTop: '40vh' }} className='d-flex justify-content-center transitionAll-1'>
                            <ProgressSpinner />
                        </div>
                        : ''}

                    <div className='transitionAll-1'>
                        <Card className={'bg-' + config.theme.toLowerCase()} contenido={(
                            <div>
                                <h4 className='m-auto text-center'>Circular </h4>
                                <div className='row'>
                                    <div className="col-6">
                                        <Chart height={heightKPI} type="bar" data={knittingCircularDataWeek.dataWeek} options={knittingCircularDataWeek.OptionsWeek} plugins={[ChartDataLabels]} />
                                    </div>
                                    <div className="col-6">
                                        <Chart height={heightKPI} type='line' data={knittingCircularDataDays.dataDay} options={knittingCircularDataDays.OptionsDay} plugins={[ChartDataLabels]} />
                                    </div>
                                </div>
                            </div>

                        )} />
                        <Card className={'bg-' + config.theme.toLowerCase()} contenido={(
                            <div>
                                <h4 className='m-auto text-center'>Tricot </h4>
                                <div className='row'>
                                    <div className="col-6">
                                        <Chart height={heightKPI} type="bar" data={knittingTricotDataWeek.dataWeek} options={knittingTricotDataWeek.OptionsWeek} plugins={[ChartDataLabels]} />
                                    </div>
                                    <div className="col-6">
                                        <Chart height={heightKPI} type='line' data={knittingTricotDataDays.dataDay} options={knittingTricotDataDays.OptionsDay} plugins={[ChartDataLabels]} />
                                    </div>
                                </div>
                            </div>

                        )} />

                    </div>

                </div>

                )
            }
            />
        </div>
    )
}

export default KnittingProduction